import { Component } from '@angular/core';

@Component({
    selector: 'app-hr',
    templateUrl: './hr.component.html',
    styleUrls: ['./hr.component.scss'],
    standalone: false
})
export class HrComponent {}
